import {CHANGE_CATEGORY} from '../actionTypes';

export function changeCategory(key){

    return {
        type: CHANGE_CATEGORY,
        key: key
    }
}


// WEBPACK FOOTER //
// ./src/actions/store/storeCategoriesActions.js